import { Suspense, ErrorBoundary } from '@suspensive/react';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import type { ErrorInfo } from 'react';

type ErrorFallbackRender = (props: {
  error: unknown;
  reset: () => void;
}) => React.ReactNode;

type BoundaryProps = {
  loadingFallback: React.ReactNode;
  errorFallback: ErrorFallbackRender;
  onError?: (error: Error, info: ErrorInfo) => void;
  children: React.ReactNode;
};

export const Boundary = ({
  loadingFallback,
  errorFallback,
  onError,
  children,
}: BoundaryProps) => (
  <QueryErrorResetBoundary>
    {({ reset }) => (
      <ErrorBoundary onReset={reset} onError={onError} fallback={errorFallback}>
        <Suspense fallback={loadingFallback}>{children}</Suspense>
      </ErrorBoundary>
    )}
  </QueryErrorResetBoundary>
);
